var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5314_6971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 25,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5314_6971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3461 12L9.55444 7.40001L10.2917 6.69226L15.8206 12L10.2917 17.3078L9.55444 16.6L14.3461 12Z",
    fill: "#0E9384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForwardIcon);
export default __webpack_public_path__ + "static/media/chevron-forward-icon.4a34bdb31a45e5a278fb970835a29eb9.svg";
export { ForwardRef as ReactComponent };